/**
 * 
 */
export class VehicleBrand {
  
  private _id: number;
  get id(): number { return this._id; }
  set id(_id: number) { this._id = _id; }

  private _name: string;
  get name(): string { return this._name; }
  set name(_name: string) { this._name = _name; }

  constructor(_id?: number, _name?: string) {
    this._id = _id? _id : 0;
    this._name = _name? _name : '';
  }
}